import React from 'react';
import { Clock, LogIn, LogOut, Calendar, Timer } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const AttendanceComponent = ({
                                 attendance = [],
                                 canCheckIn = false,
                                 canCheckOut = false,
                                 onCheckIn = () => {},
                                 onCheckOut = () => {},
                             }) => {
    const fmtTime = (iso) => new Date(iso).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
    const fmtDate = (iso) => new Date(iso).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' });

    const totalHours = () => {
        let minutes = 0, inTime = null;
        attendance.forEach(({ type, occurred_at }) => {
            if (type === 'IN') inTime = new Date(occurred_at);
            else if (inTime) {
                minutes += (new Date(occurred_at) - inTime) / (1000 * 60);
                inTime = null;
            }
        });
        return `${Math.floor(minutes / 60)}h ${Math.floor(minutes % 60)}m`;
    };

    return (
        <div className="max-w-3xl mx-auto space-y-6">
            {/* Main Card */}
            <Card>
                <CardHeader>
                    <CardTitle className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <Clock size={22} /> Attendance
                        </div>
                        {attendance.length > 0 && (
                            <Badge variant="outline">
                                {attendance[attendance.length - 1].type === 'IN' ? 'Checked In' : 'Checked Out'}
                            </Badge>
                        )}
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                    {/* Stats */}
                    <div className="grid grid-cols-2 gap-4">
                        <Card className="bg-slate-50">
                            <CardContent className="p-3 flex justify-between items-center">
                                <div>
                                    <p className="text-sm text-slate-500">Total Hours</p>
                                    <p className="text-lg font-semibold">{totalHours()}</p>
                                </div>
                                <Timer size={20} />
                            </CardContent>
                        </Card>
                        <Card className="bg-slate-50">
                            <CardContent className="p-3 flex justify-between items-center">
                                <div>
                                    <p className="text-sm text-slate-500">Sessions</p>
                                    <p className="text-lg font-semibold">{Math.ceil(attendance.length / 2)}</p>
                                </div>
                                <Calendar size={20} />
                            </CardContent>
                        </Card>
                    </div>

                    {/* Buttons */}
                    <div className="flex gap-3">
                        <Button onClick={onCheckIn} disabled={!canCheckIn} className="flex-1">
                            <LogIn size={16} className="mr-1" /> Check In
                        </Button>
                        <Button onClick={onCheckOut} disabled={!canCheckOut} variant="destructive" className="flex-1">
                            <LogOut size={16} className="mr-1" /> Check Out
                        </Button>
                    </div>
                </CardContent>
            </Card>

            {/* Timeline */}
            <Card>
                <CardHeader>
                    <CardTitle className="flex items-center gap-2">
                        <Calendar size={20} /> Today's Timeline
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    {attendance.length === 0 ? (
                        <p className="text-center text-slate-500 py-6">No records today</p>
                    ) : (
                        <div className="space-y-3">
                            {attendance.map(({ id, type, method, occurred_at }) => (
                                <div key={id} className="flex justify-between items-center p-3 bg-slate-50 rounded-lg">
                                    <div className="flex items-center gap-3">
                                        {type === 'IN' ? <LogIn size={16} /> : <LogOut size={16} />}
                                        <div>
                                            <p className="font-medium">{type === 'IN' ? 'Checked In' : 'Checked Out'}</p>
                                            <p className="text-sm text-slate-500">{method}</p>
                                        </div>
                                    </div>
                                    <div className="text-right text-sm text-slate-600">
                                        <p>{fmtTime(occurred_at)}</p>
                                        <p>{fmtDate(occurred_at)}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </CardContent>
            </Card>
        </div>
    );
};

export default AttendanceComponent;